// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconArrowsArrowOutlineVisuallyCenteredDown_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s8IconSvg = html `<svg viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M3.99991 4.37789L6.4696 1.9082L7.53027 2.96886L3.99991 6.49922L0.469604 2.96891L1.53027 1.90825L3.99991 4.37789Z" class="svg-bg"/>
</svg>
`;
const _s12IconSvg = html `<svg viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M6.00004 6.87789L8.96973 3.9082L10.0304 4.96886L6.00003 8.99922L1.96973 4.96886L3.03039 3.90821L6.00004 6.87789Z" class="svg-bg"/>
</svg>
`;
const _s16IconSvg = html `<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M7.99996 10.1718L13.2929 4.87891L14.7071 6.29312L7.99996 13.0002L1.29285 6.29312L2.70706 4.87891L7.99996 10.1718Z" class="svg-bg"/>
</svg>
`;
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M12 15.4735L20.6161 6.85742L22.3839 8.62519L12 19.0091L1.61609 8.62519L3.38386 6.85742L12 15.4735Z" class="svg-bg"/>
</svg>
`;
const _s32IconSvg = html `<svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M15.9999 25.0004L1.93921 10.9397L4.06053 8.81836L15.9999 20.7577L27.9392 8.81836L30.0605 10.9397L15.9999 25.0004Z" class="svg-bg"/>
</svg>
`;
/**
 * IconArrowsArrowOutlineVisuallyCenteredDown is a generated icon component.
 */
let IconArrowsArrowOutlineVisuallyCenteredDown = IconArrowsArrowOutlineVisuallyCenteredDown_1 = class IconArrowsArrowOutlineVisuallyCenteredDown extends IconBaseElement {
    render() {
        return html `${IconArrowsArrowOutlineVisuallyCenteredDown_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconArrowsArrowOutlineVisuallyCenteredDown.icons = new Map([
    ['s8', _s8IconSvg],
    ['s12', _s12IconSvg],
    ['s16', _s16IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s32IconSvg],
    ['s40', _s32IconSvg],
    ['s48', _s32IconSvg],
    ['s64', _s32IconSvg],
    ['s72', _s32IconSvg],
    ['s80', _s32IconSvg],
]);
IconArrowsArrowOutlineVisuallyCenteredDown = IconArrowsArrowOutlineVisuallyCenteredDown_1 = __decorate([
    customElement('zui-icon-arrows-arrow-outline-visually-centered-down')
], IconArrowsArrowOutlineVisuallyCenteredDown);
export { IconArrowsArrowOutlineVisuallyCenteredDown };
